export function paginationNumbers(currentPage, nrOfPages) {
  const delta = 2
  const range = []
  const rangeWithDots = []
  let l

  range.push(1)

  if (!nrOfPages || nrOfPages <= 1) {
    return range
  }

  // eslint-disable-next-line no-plusplus
  for (let i = currentPage - delta; i <= currentPage + delta; i++) {
    if (i < nrOfPages && i > 1) {
      range.push(i)
    }
  }

  range.push(nrOfPages)

  range.forEach((i) => {
    if (l) {
      if (i - l === 2) {
        rangeWithDots.push(l + 1)
      } else if (i - l !== 1) {
        rangeWithDots.push('...')
      }
    }

    rangeWithDots.push(i)
    l = i
  })

  return rangeWithDots
}
